var toSentence = require('./toSentence');

module.exports = function toSentenceSerial(array, sep, lastSep) {
  return toSentence(array, sep, lastSep, true);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/toSentenceSerial.js
// module id = 2298
// module chunks = 0